import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable} from 'rxjs';
import { mergeMap, map} from 'rxjs/operators';
import { ModuleUniqueIds } from '../../../../Constants/ModuleUniqueIds';
import { IRule } from '../../../../Models/tenant';
import { TenantService } from '../../../../Services/tenant.service';
import { Field, ISaveButton, IStateNode, IStateTransition, Step } from '../Models';
import { ModuleService } from '../Services/module.service';
import { MatButton, MatIconButton } from '@angular/material/button';
import { AsyncPipe, NgFor, NgIf } from '@angular/common';
import { MatFormField, MatLabel } from '@angular/material/input';
import { MatSelect } from '@angular/material/select';
import { FormsModule } from '@angular/forms';
import { MatOption } from '@angular/material/autocomplete';
import { MatCard } from '@angular/material/card';
import { MatIcon } from '@angular/material/icon';
import { MatCheckbox } from '@angular/material/checkbox';
import { ModuleTransitionComponent } from './module.transition.component';

@Component({
    selector: 'my-modules-state',
    templateUrl: './module.state.component.html',
    
    styleUrls: ['./module.state.component.less'],
    imports: [MatButton, MatFormField, MatLabel, MatSelect, FormsModule, MatOption, MatCard, MatIcon, MatCheckbox, MatIconButton, ModuleTransitionComponent, AsyncPipe]
})
export class ModuleStateComponent implements OnInit {
    moduleId: string;
    version = 1;
    stateNodes: IStateNode[] = [];
    stateNodeFromId: number;
    stateNodeToId: number;
    stateRules: IRule[] = [];
    stateRulesToSave: number[] = [];
    conditionFields: Field[] = [];
    listItemsCache: any[] = [];
    enableSaveButton = true;
    saveButtonText = 'Save State Model';
    validationErrors: string[] = [];
    selectedStep: Step;
    selectedField: Field;

    allowedConditionFields: string[];

    newTransitionDefaultPostConditionValues: any = [
        {
            stateFromId: 2000,
            stateToId: 2010,
            postConditionValues: {
                TransitionReason: 'Initial Details Completed',
                GlobalStatusOn: 'DateTimeStamp',
                GlobalStatusOnTimeZoneOffset: '0',
            },
        },
        {
            stateFromId: 2010,
            stateToId: 2015,
            postConditionValues: {
                TransitionReason: 'Triage Required',
                TriageRequiredAlias: 'true',
            },
        },
        {
            stateFromId: 2010,
            stateToId: 2020,
            postConditionValues: {
                TransitionReason: 'Investigation Started',
                TriageRequiredAlias: 'false',
            },
        },
        {
            stateFromId: 2015,
            stateToId: 2020,
            postConditionValues: {
                TransitionReason: 'Triage Completed',
                InvestigationRequiredAlias: 'TriageInvestigationRequiredAlias',
                InvestigationRequiredText: 'TriageInvestigationRequiredText',
                InvestigatorId: 'TriageInvestigatorId',
                InvestigatorName: 'TriageInvestigatorName',
                TriageDate: 'DateStamp',
            },
        },
        {
            stateFromId: 2015,
            stateToId: 2800,
            postConditionValues: {
                TransitionReason: 'Investigation Not Required With Open Claims',
                TriageDate: 'DateStamp',
            },
        },
        {
            stateFromId: 2015,
            stateToId: 2900,
            postConditionValues: {
                TransitionReason: 'Investigation Not Required',
                TriageDate: 'DateStamp',
            },
        },
        {
            stateFromId: 2020,
            stateToId: 2030,
            postConditionValues: {
                TransitionReason: 'Investigation Completed',
                InvestigationSignOffDate: 'DateStamp',
            },
        },
        {
            stateFromId: 2020,
            stateToId: 2800,
            postConditionValues: {
                TransitionReason: 'Sign Off 1 Not Required With Open Claims',
                InvestigationSignOffDate: 'DateStamp',
            },
        },
        {
            stateFromId: 2020,
            stateToId: 2900,
            postConditionValues: {
                TransitionReason: 'Sign Off 1 Not Required',
                InvestigationSignOffDate: 'DateStamp',
            },
        },
        {
            stateFromId: 2030,
            stateToId: 2040,
            postConditionValues: {
                TransitionReason: 'Sign Off 1 Completed',
                SignOff1Date: 'DateStamp',
            },
        },
        {
            stateFromId: 2030,
            stateToId: 2800,
            postConditionValues: {
                TransitionReason: 'Sign Off 2 Not Required With Open Claims',
                SignOff1Date: 'DateStamp',
            },
        },
        {
            stateFromId: 2030,
            stateToId: 2900,
            postConditionValues: {
                TransitionReason: 'Sign Off 2 Not Required',
                SignOff1Date: 'DateStamp',
            },
        },
        {
            stateFromId: 2040,
            stateToId: 2800,
            postConditionValues: {
                TransitionReason: 'Sign Off 2 Complete With Open Claims',
                SignOff2Date: 'DateStamp',
            },
        },
        {
            stateFromId: 2040,
            stateToId: 2900,
            postConditionValues: {
                TransitionReason: 'Sign Off 2 Complete',
                SignOff2Date: 'DateStamp',
            },
        },
        {
            stateFromId: 2800,
            stateToId: 2900,
            postConditionValues: {
                TransitionReason:
                    'Really Closed Due To Claim Being Closed, Settled or Fraudulent',
            },
        },
        {
            stateFromId: 13020,
            stateToId: 13030,
            postConditionValues: {
                AuthorisedToAddDate: 'DateTimeStamp',
            },
        },
        {
            stateFromId: 13020,
            stateToId: 13100,
            postConditionValues: {
                AuthorisedToAddDate: 'DateTimeStamp',
            },
        },
        {
            stateFromId: 13020,
            stateToId: 13200,
            postConditionValues: {
                AuthorisedToAddDate: 'DateTimeStamp',
            },
        },
        {
            stateFromId: 13020,
            stateToId: 13900,
            postConditionValues: {
                AuthorisedToAddDate: 'DateTimeStamp',
            },
        },
        {
            stateFromId: 13030,
            stateToId: 13100,
            postConditionValues: {
                AuthorisedToUseDate: 'DateTimeStamp',
            },
        },
        {
            stateFromId: 13030,
            stateToId: 13200,
            postConditionValues: {
                AuthorisedToUseDate: 'DateTimeStamp',
            },
        },
        {
            stateFromId: 13030,
            stateToId: 13900,
            postConditionValues: {
                AuthorisedToUseDate: 'DateTimeStamp',
            },
        },
        {
            stateFromId: 13200,
            stateToId: 13900,
            postConditionValues: {
                ArchivedDate: 'DateTimeStamp',
            },
        },
    ];

    showTransition: boolean[] = [];

    constructor(
        private activatedRoute: ActivatedRoute,
        public moduleService: ModuleService,
        private tenantService: TenantService,
        public dialog: MatDialog,
        private ref: ChangeDetectorRef
    ) {
        this.moduleId = this.activatedRoute.parent.snapshot.params.moduleId;
        this.version = this.activatedRoute.parent.snapshot.params.version;

        switch (this.moduleId) {
            case ModuleUniqueIds.Events:
                this.allowedConditionFields = [
                    'EventTypeAlias',
                    'EventSubTypeAlias',
                    'EventSubSubTypeAlias',
                    'LegallyReportableAlias',
                    'ActualSeverityRatingAlias',
                    'PotentialSeverityRatingAlias',
                    'TriageRequiredAlias',
                    'TriageSignOff',
                    'TriageInvestigationRequiredAlias',
                    'InvestigationRequiredAlias',
                    'InvestigationSignOff',
                    'SignOff1SignOff',
                    'SignOff2SignOff',
                    'HasClaimAlias',
                    'ClaimStatusAlias',
                    'HasOpenDependentRecords',
                ];
                break;
            case ModuleUniqueIds.Risk:
                this.allowedConditionFields = [
                    'RiskAssessmentTypeAlias',
                    'ReviewIsApproved',
                    'SignOff1IsApproved',
                    'SignOff2IsApproved',
                    'SignOff3IsApproved',
                    'Archived'
                ];
                break;
            case ModuleUniqueIds.TallyIndex:
                this.allowedConditionFields = [
                    'IndustryTemplateAlias',
                    'ApprovedAlias'
                ];
                break;
            case ModuleUniqueIds.Register:
                this.allowedConditionFields = [
                    'RegisterCategoryAlias',
                    'RequestToArchive',
                    'AuthorisedToAdd',
                    'AuthorisedToUse',
                    'Archived',
                ];
                break;
            case ModuleUniqueIds.PermitToWork:
                this.allowedConditionFields = [
                    'PermitCategoryAlias',
                    'PermitTypeAliases',
                    'MethodStatementReceived',
                    'RiskAssessmentReceived',
                    'SignOff1IsApproved',
                    'SignOff2IsApproved',
                    'SignOff3IsApproved',
                    'AuthorisationToProceedIssuerAlias',
                    'AuthorisationToProceedContractorAlias'
                ];
                break;
            default:
        }
    }

    ngOnInit(): void {
        if (this.moduleId && this.moduleId.length > 0) {
            this.bindModuleStateNodes();
            this.bindModuleStateRules();
            this.bindConditionFields();
        }
    }

    async bindModuleStateNodes(): Promise<any> {
        await this.loadModuleStateContent();
        this.stateNodes = this.moduleService.moduleStateContent
            .filter((item) => item.Name !== 'New' && item.Name !== 'Deleted')
            .sort((a, b) =>
                a.ModuleStatus.Id > b.ModuleStatus.Id
                    ? 1
                    : b.ModuleStatus.Id > a.ModuleStatus.Id
                        ? -1
                        : 0
            );

        this.ref.detectChanges();
    }

    async loadModuleStateContent(): Promise<any> {
        await this.moduleService.loadModuleStateContent(
            this.tenantService.selectedTenant,
            this.moduleId,
            this.version
        );
    }

    async bindModuleStateRules(): Promise<any> {
        await this.loadModuleStateRules();
        this.stateRules = this.tenantService.stateRules;

        this.ref.detectChanges();
    }

    async loadModuleStateRules(): Promise<any> {
        await this.tenantService.loadStateRules();
    }

    async bindConditionFields(): Promise<any> {
        await this.loadModuleContent();
        this.conditionFields = this.moduleService
            .getModuleFields()
            .filter(
                (f: Field) => this.allowedConditionFields.indexOf(f.FieldId) !== -1
            );
    }

    async loadModuleContent(): Promise<any> {
        await this.moduleService.loadModuleContent(
            this.tenantService.selectedTenant,
            this.moduleId,
            this.version
        );
    }

    getModuleContentSteps(): Observable<Step[]> {
        return this.moduleService.getModuleSteps();
    }

    getModuleContentStepFields(stepId: string): Observable<Field[]> {
        return this.getModuleContentSteps().pipe(map(steps =>
            steps
                .find(step => step.StepId == stepId)?.Fields
                .sort((a, b) => this.prettifyLabel(a.FieldName).localeCompare(this.prettifyLabel(b.FieldName))))
        );
    }

    getStateNodeToOptions(): IStateNode[] {
        const selectedStates = this.stateNodes.filter(
            (s) => s.ModuleStatus.Id === this.stateNodeFromId
        );
        if (selectedStates && selectedStates.length > 0) {
            return this.stateNodes.filter(
                (s) => s.ModuleStatus.Id > this.stateNodeFromId
            );
        }
        return null;
    }

    getStateTransitions(): IStateTransition[] {
        const filteredStateNodes = this.stateNodes.filter(
            (x) => x.ModuleStatus.Id === this.stateNodeFromId
        );

        if (filteredStateNodes.length > 1) {
            throw new Error(
                `More than one state found with same ModuleStatusId: ${this.stateNodeFromId}`
            );
        } else if (filteredStateNodes.length === 0) {
            throw new Error(
                `No states found with ModuleStatusId: ${this.stateNodeFromId}`
            );
        }

        return filteredStateNodes[0].StateTransitions.filter(
            (x) => x.ModuleStatusId === this.stateNodeToId
        );
    }

    getListItems(listName: string): any[] {
        const cacheVal = this.listItemsCache[listName];
        let itemsSource: Observable<any[]>;
        if (cacheVal) {
            itemsSource = new Observable<any[]>((items: any) => items.next(cacheVal));
        } else {
            itemsSource = this.tenantService
                .getListItems(['AIRSWEBLIST', listName])
                .pipe(map((r) => r as any[]));
        }
        itemsSource.pipe(
            map((r) => {
                for (const i of r) {
                    i.shown = true;
                }
                return r;
            }),
            map((items: any) => {
                this.listItemsCache[listName] = items;
            })
        );

        return this.listItemsCache[listName];
    }

    onAddTransitionButtonClick() {
        this.addTransition();
    }

    addTransition() {
        const newTransitionDefaultPostConditionValues =
            this.newTransitionDefaultPostConditionValues.find(
                (o: any) =>
                    o.stateFromId === this.stateNodeFromId &&
                    o.stateToId === this.stateNodeToId
            );

        let newPostConditionValues: any = null;

        if (
            newTransitionDefaultPostConditionValues &&
            newTransitionDefaultPostConditionValues.hasOwnProperty(
                'postConditionValues'
            )
        )
            {newPostConditionValues =
                newTransitionDefaultPostConditionValues.postConditionValues;}

        if (!newPostConditionValues)
            {newPostConditionValues = { TransitionReason: null };}

        newPostConditionValues.ModuleStatusOn = 'DateTimeStamp';
        newPostConditionValues.ModuleStatusOnTimeZoneOffset = '0';

        const stateNodeFrom = this.stateNodes.find(
            (s) => s.ModuleStatus.Id === this.stateNodeFromId
        );
        const stateNodeTo = this.stateNodes.find(
            (s) => s.ModuleStatus.Id === this.stateNodeToId
        );

        if (stateNodeFrom.GlobalStatus.Id !== stateNodeTo.GlobalStatus.Id) {
            newPostConditionValues.GlobalStatusOn = 'DateTimeStamp';
            newPostConditionValues.GlobalStatusOnTimeZoneOffset = '0';
        }

        let saveButton: ISaveButton = null;

        if (stateNodeFrom.ShowSoftSaveButton) {
            saveButton = {
                ModuleStatusId: stateNodeTo.ModuleStatusId,
                Label: 'common:Submit',
                Style: '',
                IsUnlock: false,
                IsDeleted: false,
                MoveNext: false,
                TriggerFields: null,
            };
        }

        const newTransition: IStateTransition = {
            Description: null,
            ModuleStatusId: this.stateNodeToId,
            Mandatory: {},
            IsApprovalTransition: stateNodeFrom.IsSignOffState,
            IsRejectionTransition: false,
            PreConditionRules: [],
            PostConditionValues: newPostConditionValues,
            SaveButton: saveButton,
        };

        this.stateNodes
            .find((s) => s.ModuleStatus.Id === this.stateNodeFromId)
            .StateTransitions.push(newTransition);
    }

    onSaveButtonClick() {
        this.masterSave();
    }

    masterSave() {
        this.saveButtonText = 'Saving...';

        this.validationErrors = this.moduleService
            .validateModuleStateContent()
            .concat(this.tenantService.validateStateRules(this.stateRulesToSave));

        if (!this.validationErrors || this.validationErrors.length === 0)
            {this.saveStateRules()
                .pipe(
                    mergeMap(() => {
                        this.stateRulesToSave = [];
                        return this.saveStateModel();
                    })
                )
                .subscribe(() => {
                    this.saveButtonText = 'Saved';
                });}
        else {
            this.saveButtonText = 'Save State Model';
        }
    }

    saveStateRules(): Observable<any> {
        return this.tenantService.saveStateRules(
            this.moduleId,
            this.stateRulesToSave
        );
    }

    saveStateModel(): Observable<any> {
        return this.moduleService.updateModuleStateContent(
            this.tenantService.selectedTenant,
            this.moduleId,
            this.version
        );
    }

    prettifyLabel(lbl: string): string {
        let op: string;
        if (!lbl) {
            console.log('label undefined');
            return '';
        }
        if (lbl.indexOf(':') > -1) {
            op = lbl.split(':')[1];
        } else {
            op = lbl;
        }

        return op.replace(/_/g, ' ');
    }

    fieldIsMandatoryAtState(field: Field, state: IStateNode): boolean {
        return state.MandatoryOnlyAtStateFields.indexOf(field.FieldId) !== -1;
    }

    updateFieldIsMandatoryAtState(field: Field, state: IStateNode, isMandatory: boolean) {
        const itemIndex = state.MandatoryOnlyAtStateFields.indexOf(field.FieldId);

        if (isMandatory && itemIndex === -1) {
            state.MandatoryOnlyAtStateFields.push(field.FieldId);
        }
        else if (!isMandatory && itemIndex !== -1) {
            state.MandatoryOnlyAtStateFields.splice(itemIndex, 1);
        }
    }

    allMandatorySelected(): boolean {
        if (!this.selectedField || !this.stateNodes?.length) { return false; }
        return this.stateNodes.every(state => this.fieldIsMandatoryAtState(this.selectedField, state));
    }

    someMandatorySelected(): boolean {
        if (!this.selectedField || !this.stateNodes?.length) { return false; }
        const count = this.stateNodes.filter(state => this.fieldIsMandatoryAtState(this.selectedField, state)).length;
        return count > 0 && count < this.stateNodes.length;
    }

    toggleSelectAllMandatory(checked: boolean) {
        if (!this.selectedField || !this.stateNodes?.length) { return; }
        this.stateNodes.forEach(state => this.updateFieldIsMandatoryAtState(this.selectedField, state, checked));
    }

    fieldIsEditableAtState(field: Field, state: IStateNode): boolean {
        return (state.EditableFields ?? []).indexOf(field.FieldId) !== -1;
    }

    updateFieldIsEditableAtState(field: Field, state: IStateNode, isEditable: boolean) {
        state.EditableFields = state.EditableFields ?? [];
        const itemIndex = state.EditableFields.indexOf(field.FieldId);

        if (isEditable && itemIndex === -1) {
            state.EditableFields.push(field.FieldId);
        }
        else if (!isEditable && itemIndex !== -1) {
            state.EditableFields.splice(itemIndex, 1);
        }
    }

    allEditableSelected(): boolean {
        if (!this.selectedField || !this.stateNodes?.length) { return false; }
        return this.stateNodes.every(state => this.fieldIsEditableAtState(this.selectedField, state));
    }

    someEditableSelected(): boolean {
        if (!this.selectedField || !this.stateNodes?.length) { return false; }
        const count = this.stateNodes.filter(state => this.fieldIsEditableAtState(this.selectedField, state)).length;
        return count > 0 && count < this.stateNodes.length;
    }

    toggleSelectAllEditable(checked: boolean) {
        if (!this.selectedField || !this.stateNodes?.length) { return; }
        this.stateNodes.forEach(state => this.updateFieldIsEditableAtState(this.selectedField, state, checked));
    }
}
